import { Box, type BoxProps, Stack } from '@mui/material';
import { type ReactNode } from 'react';

import { Text, isTruthy } from 'common';

import { BlockTypeCategoryIcon } from '../../../../BlockIcons/BlockCategories';
import type { UiBlockType } from '../../../types';

interface NodeTitleProps {
  uiBlockType: UiBlockType;
  description?: string | null;
  children: ReactNode;
  containerProps?: BoxProps;
  blockIconSubtypeVariant?: 'default' | 'large';
}

export function NodeHeader(props: NodeTitleProps) {
  const { uiBlockType, description, children, containerProps, blockIconSubtypeVariant } = props;

  return (
    <Box position="relative" {...containerProps}>
      <Stack gap={1} alignItems="start" sx={{ overflow: 'hidden' }}>
        <Stack
          direction="row"
          gap={1}
          sx={{
            justifyContent: 'left',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <BlockTypeCategoryIcon uiBlockType={uiBlockType} variant={blockIconSubtypeVariant} />
          <Box flex={1}>{children}</Box>
        </Stack>
        {isTruthy(description) ? (
          <Text
            variant="body2"
            sx={{
              maxHeight: '2.5rem',
              whiteSpace: 'pre-wrap',
              overflow: 'hidden',
            }}
          >
            {description}
          </Text>
        ) : null}
      </Stack>
    </Box>
  );
}
